module.exports = __webpack_public_path__ + "static/media/hanakawado-asakusa-6.1eb30cef.jpg";